var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDangerSign(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: 512,
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 1707 1707",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_621553136"
  }, /*#__PURE__*/React.createElement("path", {
    d: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1427 1631h-1146c-155 0-282-126-282-280 0-31 6-61 16-90 5-17 13-35 23-52l571-988c17-30 37-55 61-75l3-3s1-2 1-2c89-76 218-87 322-29 43 25 78 61 109 114l565 983c23 42 36 89 37 139v2c2 73-27 144-80 198s-124 83-200 83z",
    fill: "#ff3535"
  }), /*#__PURE__*/React.createElement("path", {
    d: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1427 1513h-1146c-89 0-162-72-162-161 0-18 2-36 9-52l2-5c3-8 5-16 11-25l571-987c9-18 21-33 36-44l1-2s2-1 2-1c52-45 126-50 184-17 29 17 53 42 66 71l566 982c14 26 21 53 21 80 0 89-72 161-161 161z",
    fill: "#ff4141"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m853 932c-50 0-91-41-91-92v-283c0-50 40-92 91-92 52 0 92 42 92 92v283c0 50-42 92-92 92z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m853 1243c-59 0-108-49-108-110 0-60 49-108 108-108 60 0 109 48 109 108 0 61-49 110-109 110z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerSign);
export default __webpack_public_path__ + "static/media/danger-sign.f867be6f2807f519ba5deca48bd3dc45.svg";
export { ForwardRef as ReactComponent };